import { setChartTitle } from "../redux/slices/uiSlice";

/**
 * Client-side reset helpers for voice-triggered portfolio selection
 * (`selectParentPortfolio` / `selectSubPortfolio`).
 *
 * Realtime/OpenAI limits: prior `conversation.item` entries may still exist server-side;
 * we clear React + localStorage history and inject a system boundary so the model should
 * not rely on pre-switch messages for portfolio facts. Full server-side truncation is not
 * implemented here.
 */

/** Close any content view so portfolio-specific UI is not left open during/after a switch. */
export function resetViewsForWorkingPortfolioChange(
  dispatch,
  setCurrentContentType,
  setOutputText,
  contentTypeNothing
) {
  setCurrentContentType(contentTypeNothing);
  setOutputText("Nothing");
  dispatch(setChartTitle(""));
}

/** Clears local Q&A persistence and in-memory transcript after a successful portfolio context load. */
export function resetConversationForWorkingPortfolioChange(
  setConversationHistory,
  clearPartialAiResponse
) {
  try {
    localStorage.removeItem("conversationHistory");
  } catch (_) {
    /* ignore */
  }
  setConversationHistory([]);
  if (typeof clearPartialAiResponse === "function") {
    clearPartialAiResponse();
  }
}

/** Injected into the Realtime session so the model does not treat pre-switch messages as authoritative. */
export const REALTIME_PORTFOLIO_BOUNDARY_EN =
  "Portfolio selection was just changed and the client cleared the local Q&A log. " +
  "Do not rely on earlier user or assistant messages for holdings, positions, or prior tool results; " +
  "only use the latest selectParentPortfolio or selectSubPortfolio tool output and new user messages from here on.";
